module.exports = __webpack_public_path__ + "public/img/liangbu_qr.56a98923.png";